var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M14,6.12H3.35L8.24,1.23,7,0,0,7l7,7,1.23-1.23L3.35,7.88H14Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }